export default __webpack_public_path__ + "static/media/Q1_3.db948310.png";